window.timber = window.timber || {};

timber.cacheSelectors = function () {
  timber.cache = {
    // General
    $html: $('html'),
    $body: $('body'),

    // Navigation
    $navigation: $('#AccessibleNav'),

    // Product Page
    $productImage: $('#ProductPhotoImg'),
    $thumbImages: $('#ProductThumbs').find('a.product-single__thumbnail')
  }
};

timber.init = function () {
  timber.cacheSelectors();
  timber.accessibleNav();
  timber.productImageSwitch();
  timber.responsiveVideos();
  timber.matchHeight();
  timber.ingredients();
  timber.maps();
  timber.timeToBuy();
  timber.gdpr();
  timber.newsletter();
  timber.smoothScroll();
  timber.tabs();

  timber.lockedPopup();
};

timber.lockedPopup = function () {
    console.log('modaal');
    $('.modaal-trigger').modaal({
        fullscreen: true,
        is_locked:true,

    })

    $('.modaal-trigger').trigger('click');
}

timber.accessibleNav = function () {
  var $nav = timber.cache.$navigation,
      $allLinks = $nav.find('a'),
      $topLevel = $nav.children('li').find('a'),
      $parents = $nav.find('.site-nav--has-dropdown'),
      $subMenuLinks = $nav.find('.site-nav__dropdown').find('a'),
      activeClass = 'nav-hover',
      focusClass = 'nav-focus';

  // Mouseenter
  $parents.on('mouseenter touchstart', function(evt) {
    var $el = $(this);

    if (!$el.hasClass(activeClass)) {
      evt.preventDefault();
    }

    showDropdown($el);
  });

  // Mouseout
  $parents.on('mouseleave', function() {
    hideDropdown($(this));
  });

  $subMenuLinks.on('touchstart', function(evt) {
    // Prevent touchstart on body from firing instead of link
    evt.stopImmediatePropagation();
  });

  $allLinks.focus(function() {
    handleFocus($(this));
  });

  $allLinks.blur(function() {
    removeFocus($topLevel);
  });

  // accessibleNav private methods
  function handleFocus ($el) {
    var $subMenu = $el.next('ul'),
        hasSubMenu = $subMenu.hasClass('sub-nav') ? true : false,
        isSubItem = $('.site-nav__dropdown').has($el).length,
        $newFocus = null;

    // Add focus class for top level items, or keep menu shown
    if (!isSubItem) {
      removeFocus($topLevel);
      addFocus($el);
    } else {
      $newFocus = $el.closest('.site-nav--has-dropdown').find('a');
      addFocus($newFocus);
    }
  }

  function showDropdown ($el) {
    $el.addClass(activeClass);

    setTimeout(function() {
      timber.cache.$body.on('touchstart', function() {
        hideDropdown($el);
      });
    }, 250);
  }

  function hideDropdown ($el) {
    $el.removeClass(activeClass);
    timber.cache.$body.off('touchstart');
  }

  function addFocus ($el) {
    $el.addClass(focusClass);
  }

  function removeFocus ($el) {
    $el.removeClass(focusClass);
  }
};

timber.newsletter = function () {
  $('.ajax-form').submit(function(e) {
    e.preventDefault();

    var $this = $(this),
      $emailInput = $this.find('.email-input');

    if($emailInput.val() !== '') {
      $.getJSON(
        this.action + "?callback=?",
        $(this).serialize(),
        function (data) {
          if (data.Status === 400) {
            // error
          } else {
            // success
            $this.html('<div class="note form-success mb0">Bedankt om in te schrijven.</div>')
          }
        });
    }
  });
};

timber.productPage = function (options) {
  var moneyFormat = options.money_format,
      variant = options.variant,
      selector = options.selector;

  // Selectors
  var $productImage = $('#ProductPhotoImg'),
      $addToCart = $('#AddToCart'),
      $productPrice = $('#ProductPrice'),
      $comparePrice = $('#ComparePrice'),
      $quantityElements = $('.quantity-selector, label + .js-qty'),
      $addToCartText = $('#AddToCartText');

  if (variant) {

    // Update variant image, if one is set
    if (variant.featured_image) {
      var newImg = variant.featured_image,
          el = $productImage[0];
      Shopify.Image.switchImage(newImg, el, timber.switchImage);
    }

    // Select a valid variant if available
    if (variant.available) {
      // Available, enable the submit button, change text, show quantity elements
      //$addToCart.removeClass('disabled').prop('disabled', false);
      $addToCartText.html("Toevoegen aan winkelwagentje");
      $quantityElements.show();
    } else {
      // Sold out, disable the submit button, change text, hide quantity elements
      //$addToCart.addClass('disabled').prop('disabled', true);
      //$addToCartText.html("Uitverkocht");
      $quantityElements.hide();
    }

    // Regardless of stock, update the product price
    $productPrice.html( Shopify.formatMoney(variant.price, moneyFormat) );

    // Also update and show the product's compare price if necessary
    if (variant.compare_at_price > variant.price) {
      $comparePrice
        .html("Vergelijken met" + ': ' + Shopify.formatMoney(variant.compare_at_price, moneyFormat))
        .show();
    } else {
      $comparePrice.hide();
    }

  } else {
    // The variant doesn't exist, disable submit button.
    // This may be an error or notice that a specific variant is not available.
    // To only show available variants, implement linked product options:
    //   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
    $addToCart.addClass('disabled').prop('disabled', true);
    $addToCartText.html("Niet beschikbaar");
    $quantityElements.hide();
  }
};

timber.productImageSwitch = function () {
  if (timber.cache.$thumbImages.length) {
    // Switch the main image with one of the thumbnails
    // Note: this does not change the variant selected, just the image
    timber.cache.$thumbImages.on('click', function(evt) {
      evt.preventDefault();
      var newImage = $(this).attr('href');
      timber.switchImage(newImage, null, timber.cache.$productImage);
    });
  }
};


timber.gdpr = function(){
	$('input#gdpr').change(function() {
		if ($('input#gdpr').is(':checked')) {
			$('#contact-submit').prop("disabled", false);

		} else {
			$('#contact-submit').prop("disabled", true);
		}
	});
};

timber.switchImage = function (src, imgObject, el) {
  // Make sure element is a jquery object
  var $el = $(el);
  $el.attr('src', src);
};

timber.responsiveVideos = function () {
  $('iframe[src*="youtube.com/embed"]').wrap('<div class="video-wrapper"></div>');
  $('iframe[src*="player.vimeo"]').wrap('<div class="video-wrapper"></div>');
};

timber.matchHeight = function () {
  $('.mh > *').matchHeight();
  
  $(".mh-2 > *").matchHeight({ byRow: true });
  if ( $('.mh-item').length ) {
    $(".mh-item").matchHeight();
  }

};

timber.ingredients = function () {
  var firstClickIngredient = 0;
  $( ".show-ingredient" ).click(function() {
    firstClickIngredient = 1;
    
    var myTag = $(this).data( "tag" );
    
    $( ".ingredient" ).hide();
    
    $( "#ingredient-" + myTag ).css('opacity', 0).slideDown(500).animate(
      { opacity: 1 },
      { queue: false, duration: 500 }
    );
  });
  
  //ingredients
  
  var selector = '.product-single .tags li';

  $(selector).on('click', function(){
      $(selector).removeClass('active');
      $(this).addClass('active');
  });
};

timber.timeToBuy = function() {

  $.ajax({
    type: "get",
    url: "https://www.insieme.eu/time",
    data: {},
    dataType: "json",
    success: function( data ) {

      parseTime(data);

    }
  });

  function addZero(i) {
      if (i < 10) {
          i = "0" + i;
      }
      return i;
  }

  function parseTime(data) {
    var time = data.year + "-" + data.month + "-" + data.day + " " + data.hours + ":" + data.minutes + ":" + data.seconds;
    var mTime = moment(time, 'YYYY-M-D H:m:s');
    var hours = mTime.format('H');
    var minutes = mTime.format('m');
    var minZero = addZero((mTime.format('m')).slice(-2));
    var hoursZero = addZero((mTime.format('H')).slice(-2));

    showButtons(hours, minutes, hoursZero, minZero);
  }

  function showButtons(hours, minutes, hoursZero, minZero) {

    if( $('.sell-wrapper').length ) {
      if(hours > 0 && (hoursZero + ':' + minZero < 17 + ':' + 30) ){

		   $('.sell-wrapper .time-to-sell').show();
		   $('.sell-wrapper .no-time-to-sell').hide();

      } else {
        $('.sell-wrapper .time-to-sell').hide();
        $('.sell-wrapper .no-time-to-sell').show();
      }

    }

  }

};

timber.smoothScroll = function () {
	$('a.smooth').click(function () {

		var target = $(this.hash);
		target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
		if (target.length) {
			$('html,body').animate({
					scrollTop: target.offset().top - 50
				},
				1000
			);
			return false;
		}

	});
	$(window).load(function(){
		var $val = $(location.hash);
		if(window.location.hash != ''){

			$('html,body').animate({
				scrollTop: $val.offset().top - '110'
			}, 1000);
		}
    });
};

timber.tabs = function() {

  if ($('.tabs').length) {

    $('.tabs-list__link').on('click', function(e) {
      e.preventDefault();

      var target = $(this).attr('href');

      $('.tabs-list li').removeClass('active');
      $(this).parents('li').addClass('active');

      $('.tabs-content').removeClass('active');
      $('#' + target).addClass('active');

      history.replaceState(null,null,'#' + target);

    });

    var hash = window.location.hash;
    if (hash != '') {
      hash = hash.replace('#','');
      $('.tabs-list__link[href="'+ hash +'"]').trigger('click');
      $.fn.matchHeight._update()
    }

  }

};

timber.maps = function () {

  if($('#map').length) {
    var map = addContactGoogleMaps("map", 50.943011, 4.151017);
    addContactGoogleMapsMarker(map, 51.0043637,3.7527008, "Bistro Insieme Merelbeke", "https://www.google.be/maps/place/Guldensporenpark,+9820+Merelbeke/@51.0043637,3.7527008,17z");
    addContactGoogleMapsMarker(map, 51.0134795,4.486658, "Bistro Insieme De Mot Mechelen", "https://www.google.be/maps/place/Motstraat+30,+2800+Mechelen/@51.0134795,4.486658,17z");
  }

  function addContactGoogleMaps(container, latitude, longitude) {

    var zoom = 10,
        disable = true,
        scroll = false,
        styledMap = new google.maps.StyledMapType(
            [
              {
                "featureType": "all",
                "elementType": "all",
                "stylers": [
                  {
                    "visibility": "on"
                  }
                ]
              },
              {
                "featureType": "administrative",
                "elementType": "all",
                "stylers": [
                  {
                    "visibility": "on"
                  }
                ]
              },
              {
                "featureType": "landscape",
                "elementType": "all",
                "stylers": [
                  {
                    "visibility": "on"
                  },
                  {
                    "color": "#f3f9f9"
                  }
                ]
              },
              {
                "featureType": "landscape.natural",
                "elementType": "geometry.fill",
                "stylers": [
                  {
                    "visibility": "on"
                  },
                  {
                    "color": "#f3f9f9"
                  }
                ]
              },
              {
                "featureType": "poi",
                "elementType": "all",
                "stylers": [
                  {
                    "visibility": "on"
                  }
                ]
              },
              {
                "featureType": "poi",
                "elementType": "geometry.fill",
                "stylers": [
                  {
                    "visibility": "on"
                  },
                  {
                    "color": "#f3f9f9"
                  }
                ]
              },
              {
                "featureType": "road",
                "elementType": "all",
                "stylers": [
                  {
                    "visibility": "on"
                  }
                ]
              },
              {
                "featureType": "road",
                "elementType": "geometry",
                "stylers": [
                  {
                    "lightness": 100
                  },
                  {
                    "visibility": "on"
                  }
                ]
              },
              {
                "featureType": "road",
                "elementType": "geometry.stroke",
                "stylers": [
                  {
                    "color": "#ffffff"
                  },
                  {
                    "weight": "0.60"
                  },
                  {
                    "visibility": "on"
                  }
                ]
              },
              {
                "featureType": "road",
                "elementType": "labels",
                "stylers": [
                  {
                    "visibility": "off"
                  }
                ]
              },
              {
                "featureType": "road",
                "elementType": "labels.text.stroke",
                "stylers": [
                  {
                    "color": "#0c0202"
                  },
                  {
                    "visibility": "off"
                  }
                ]
              },
              {
                "featureType": "transit.line",
                "elementType": "geometry",
                "stylers": [
                  {
                    "visibility": "on"
                  },
                  {
                    "lightness": 700
                  }
                ]
              },
              {
                "featureType": "water",
                "elementType": "all",
                "stylers": [
                  {
                    "color": "#96d2d2"
                  },
                  {
                    "visibility": "on"
                  }
                ]
              },
              {
                "featureType": "water",
                "elementType": "geometry.fill",
                "stylers": [
                  {
                    "color": "#96d2d2"
                  },
                  {
                    "visibility": "on"
                  }
                ]
              },
              {
                "featureType": "water",
                "elementType": "labels",
                "stylers": [
                  {
                    "visibility": "simplified"
                  }
                ]
              }
            ],
            {name: "Styled Map"}
        ),
        mapCenter = new google.maps.LatLng(latitude, longitude),
        mapOptions = {
          zoom: zoom,
          panControl: true,
          zoomControl: disable,
          scaleControl: true,
          mapTypeControl: false,
          streetViewControl: false,
          overviewMapControl: false,
          minZoom : 2,
          scrollwheel: scroll,
          center: mapCenter,
          mapTypeId: google.maps.MapTypeId.ROADMAP
        },
        map = new google.maps.Map(document.getElementById(container), mapOptions);

    map.mapTypes.set('map_style', styledMap);
    map.setMapTypeId('map_style');

    google.maps.event.addDomListener(window, 'resize', function() {
      map.setCenter(mapCenter);
    });

    return map;
  }

  function addContactGoogleMapsMarker(map, latitude, longitude, title, extern_url) {

    var marker_image = {
      url: "https://cdn.shopify.com/s/files/1/1311/8009/files/marker_2x.png?1015251165730124549",
      anchor: new google.maps.Point(21, 25),
      scaledSize: new google.maps.Size(42, 50)
    };

    var myLatlng = new google.maps.LatLng(latitude, longitude),
        marker = new google.maps.Marker({
          position: myLatlng,
          map: map,
          icon: marker_image
        });

    google.maps.event.addListener(marker, "click", function() {
      window.open(extern_url, '_blank');
    });

    return marker;
  }

};

// Initialize Timber's JS on docready
$(timber.init);

function countDownHomePage() {
  const finaleDate = new Date("June 09, 2021 08:00:00").getTime();

  const timer = () =>{
      const now = new Date().getTime();
      let diff = finaleDate - now;
      if(diff < 0){
          document.querySelector('.home-intro').style.display = 'block';
          document.querySelector('.countdown-container').style.display = 'none';
      }

      let days = Math.floor(diff / (1000*60*60*24));
      let hours = Math.floor(diff % (1000*60*60*24) / (1000*60*60));
      let minutes = Math.floor(diff % (1000*60*60)/ (1000*60));
      let seconds = Math.floor(diff % (1000*60) / 1000);

      days <= 99 ? days = `${days}` : days;
      days <= 9 ? days = `${days}` : days;
      hours <= 9 ? hours = `0${hours}` : hours;
      minutes <= 9 ? minutes = `0${minutes}` : minutes;
      seconds <= 9 ? seconds = `0${seconds}` : seconds;   

      document.querySelector('#days').textContent = days;
      document.querySelector('#hours').textContent = hours;
      document.querySelector('#minutes').textContent = minutes;
      document.querySelector('#seconds').textContent = seconds;

  }

  timer();
  setInterval(timer,1000);
}

countDownHomePage();